import { render, staticRenderFns } from "./ProductionOrderCardMenuOptions.vue?vue&type=template&id=1a774c18&"
import script from "./ProductionOrderCardMenuOptions.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderCardMenuOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports